import { SubjectsMenuPopoutSection } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SubjectsMenuPopoutSection/SubjectsMenuPopoutSection";
import { subjectsMenuPopoutContainer } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SubjectsMenu/SubjectsMenuPopout/SubjectsMenuPopout.styles";

const SubjectsMenuPopout = () => {
  return (
    <div css={subjectsMenuPopoutContainer}>
      <SubjectsMenuPopoutSection />
    </div>
  );
};

SubjectsMenuPopout.displayName = "SubjectsMenuPopout";
export { SubjectsMenuPopout };
